import React, { useId, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import P from '@hero/ui-kit/typography/P';
import { MarkButton, MarkLabel, MarkSelect } from '../../../components/MarkControls';
import * as layout from '../../../components/markLayout.module.css';
import type { BlastDetail } from '../../../types';

type Props = { blast: BlastDetail };
const Content: React.FC<Props> = ({ blast }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const selectorId = useId();
    const [activeVariant, setActiveVariant] = useState(blast.variants[0]?.label ?? '');
    const selected =
        blast.variants.find((variant) => variant.label === activeVariant) ?? blast.variants[0];
    if (!selected) return <P>No variants.</P>;
    const isEditable = blast.status === 'DRAFT';
    const openEditor = () => {
        const search = new URLSearchParams(location.search);
        search.set('variant', selected.label);
        navigate({
            pathname: `/mark/blasts/${blast.blast_id}/template`,
            search: search.toString()
        });
    };
    return (
        <div className={layout.form}>
            <div className={layout.field} style={{ maxWidth: '40rem' }}>
                <MarkLabel htmlFor={selectorId}>Template variant</MarkLabel>
                <MarkSelect
                    id={selectorId}
                    value={selected.label}
                    onChange={(event) => setActiveVariant(event.currentTarget.value)}
                >
                    {blast.variants.map((variant) => (
                        <option key={variant.label} value={variant.label}>
                            {variant.label} ({variant.ratio}%)
                        </option>
                    ))}
                </MarkSelect>
            </div>
            <P noDefaultMargin styles={{ color: 'var(--mark-muted)' }}>
                {isEditable
                    ? 'Choose a library template, build with blocks, or paste HTML for this variant.'
                    : `Content is read-only because this blast is ${blast.status.toLowerCase()}.`}
            </P>
            <MarkButton
                size="regular"
                variant="primary"
                onClick={openEditor}
                style={{ alignSelf: 'flex-start' }}
            >
                {isEditable
                    ? selected.has_content
                        ? 'Edit template'
                        : 'Choose or create email'
                    : 'View template'}
            </MarkButton>
        </div>
    );
};
export default Content;
